import {
  Avatar,
  Dialog,
  DialogContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import DialogHeader from 'components/DialogHeader';
import { useAppDispatch, useAppSelector } from 'store';
import { EquipeInterface } from 'store/reducers/equipes';
import { fetchMinhasEquipes, usuariosSelector } from 'store/reducers/usuarios';

type ModalMinhasEquipesProps = {
  open: boolean;
  onClose: () => void;
};

export default function ModalMinhasEquipes(props: ModalMinhasEquipesProps) {
  const { open, onClose } = props;
  const dispatch = useAppDispatch();
  const { minhasEquipes, loadingMinhasEquipes } =
    useAppSelector(usuariosSelector);

  const items = loadingMinhasEquipes
    ? Array.from(new Array(4) as EquipeInterface[])
    : minhasEquipes;
  const renderEquipes = items.map((equipe, index) => {
    const key = equipe ? equipe.id : index;

    if (equipe) {
      return (
        <ListItem key={key} disableGutters>
          <ListItemAvatar style={{ minWidth: 24 }}>
            <Typography color="textSecondary">{index + 1}</Typography>
          </ListItemAvatar>

          <ListItemText
            primary={equipe.nome}
            primaryTypographyProps={{ noWrap: true }}
          />
        </ListItem>
      );
    }

    return (
      <ListItem key={key} disableGutters>
        <ListItemAvatar>
          <Skeleton variant="circle">
            <Avatar />
          </Skeleton>
        </ListItemAvatar>
        <ListItemText primary={<Skeleton variant="rect" />} />
      </ListItem>
    );
  });

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      TransitionProps={{
        onEnter: () => dispatch(fetchMinhasEquipes()),
      }}
    >
      <DialogHeader title="Minhas equipes" onClose={onClose} />
      <DialogContent>
        <List dense>
          {renderEquipes}

          {!loadingMinhasEquipes && minhasEquipes.length <= 0 && (
            <ListItem disableGutters>
              <ListItemText primary="Você ainda não faz parte de nenhuma equipe." />
            </ListItem>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
}
